import { getCurrentInstance, computed } from 'vue'

export function useVisibility() {
    const { proxy } = getCurrentInstance()
    const auth = proxy.$auth

    const showTax = computed(() => {
        const showEmployeeTax = auth.isEmployee() && import.meta.env.VITE_SHOW_TAX_CLIENT === 'true'
        const showEmployerTax = auth.isEmployer() && import.meta.env.VITE_SHOW_TAX_COMPANY === 'true'
        const showAdminTax = auth.isAdmin() && import.meta.env.VITE_SHOW_TAX_ADMIN === 'true'
        return showEmployeeTax || showEmployerTax || showAdminTax
    })

    const showAutoSettlement = computed(() => {
        const showEmployeeAutoSettlement = auth.isEmployee() && import.meta.env.VITE_SHOW_AUTOPROCESS_CLIENT === 'true'
        const showEmployerAutoSettlement = auth.isEmployer() && import.meta.env.VITE_SHOW_AUTOPROCESS_COMPANY === 'true'
        const showAdminAutoSettlement = auth.isAdmin() && import.meta.env.VITE_SHOW_AUTOPROCESS_ADMIN === 'true'
        return showEmployeeAutoSettlement || showEmployerAutoSettlement || showAdminAutoSettlement
    })

    return {
        showTax,
        showAutoSettlement
    }
}
